

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AbstractItemModel } from '@/models/items/abstract-item-model';

import axios from 'axios';
import { UploadUtils } from '@/utils/upload-utils';

import { ProductItem } from '@/models/items/product-item-model';

import * as secrets from '@/secrets';

@Component({})
export default class AbstractAddItem_GoogleSearch_Step1 extends Vue {
  @Prop(String) SEARCH_CX: string;
  @Prop(String) SEARCH_KEY: string;
  @Prop(String) instructions: string;
  @Prop(String) placeholder: string;
  @Prop(String) buttonText: string;
  @Prop(Object) item: AbstractItemModel;

  public query: string = '';

  public searchResults: any[] = [];

  public searchUrl = 'https://www.googleapis.com/customsearch/v1';

  public getImage(result: any): string {
    if (result && result.pagemap && result.pagemap.cse_image) {
      return result.pagemap.cse_image[0].src;
    } else if (result && result.pagemap && result.pagemap.cse_thumbnail) {
      return result.pagemap.cse_thumbnail[0].src;
    } else {
      return undefined;
    }
  }

  public renderGoogleResponse(results: any) {
    this.searchResults = [];
    results.items.forEach((item: any) => {
      this.searchResults.push({
        name: item.title,
        snippet: item.snippet,
        link: item.link,
        displayLink: item.displayLink,
        id: item.cacheId,
        img: this.getImage(item)
      });
    });
  }

public submit() {
    const self = this;
    axios({
      url: this.searchUrl,
      params: {
        cx: this.SEARCH_CX,
        key: this.SEARCH_KEY,
        q: this.query
      }
    })
      .then(function(response) {
        // handle success
        self.renderGoogleResponse(response.data);
      })
      .catch(function(error) {
        // handle error
        
      })
      .finally(function() {
        // always executed
      });
  }

  public goToNextStep() {
    this.$emit('go-to-next-step', {
      item: this.item,
      query: this.query
    });
  }

  public async searchResultClicked(result: any) {
    if (result.img) {
      await UploadUtils.uploadImageToFirebaseFromUrl(result.img).catch((e) => {
        console.error('failed to fetch ', result.img, e)
      }).then((imageURL) => this.item.imageURL = imageURL as string)
    }

    this.item.url = result.link;
    this.item.title = result.title;
    this.goToNextStep();
  }
}
